import { NgModule } from '@angular/core';

import { AiSupportMessageComponent } from './ai-support.message.component';
import { AiSupportPanelComponent }   from './ai-support.panel.component';
import { SharedModule }              from '../shared/shared.module';

@NgModule({
  declarations: [
    AiSupportMessageComponent,
    AiSupportPanelComponent
  ],
  entryComponents: [
    AiSupportPanelComponent
  ],
  exports: [
    AiSupportPanelComponent
  ],
  imports: [
    SharedModule
  ]
})
export class AiSupportModule {}
